export const scrollTo = (itemId, block = 'center') => {
  const element = document.querySelector(`#${CSS.escape(itemId)}`);
  if (element) {
    element.scrollIntoView({ behavior: 'smooth', block });
  }
};
